module.exports = __webpack_public_path__ + "static/assets/6109659703109e02be27d559070ca726.png";